import { useState } from "react";
import Navbar from "../../components/navigationBar";
import "./BuatAkunPage.scss";
import { registerUserNasabah } from "../../api";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import { UserPlus, Save } from "lucide-react";

export default function BuatAkunPage() {
  const [nama, setNama] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nik, setNik] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!/^\d{1,16}$/.test(nik)) {
      setMsg("NIK harus berupa angka dan maksimal 16 digit.");
      return;
    }

    if (password !== confirmPassword) {
      setMsg("Password dan konfirmasi password tidak sama.");
      return;
    }

    setLoading(true);

    try {
      const token =
        localStorage.getItem("adminToken") ||
        sessionStorage.getItem("adminToken");

      await registerUserNasabah({
        nama,
        password,
        nik,
        phone,
        token,
      });

      setMsg("Akun nasabah berhasil dibuat!");
      setNama("");
      setPassword("");
      setConfirmPassword("");
      setNik("");
      setPhone("");

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Akun nasabah berhasil dibuat!",
        confirmButtonColor: "#4f46e5",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err.response?.msg || "Terjadi kesalahan. Coba lagi.",
        confirmButtonColor: "#ef4444",
      });
      setMsg(err.response?.msg || "Terjadi kesalahan. Coba lagi.");
    }

    setLoading(false);
  };

  return (
    <div className="buat-akun-container">
      <Navbar />
      <div className="content-wrapper">
        <motion.div
          className="form-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <h2><UserPlus size={24} style={{ marginBottom: -5, marginRight: 8 }} /> Buat Akun Nasabah</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nama Lengkap Nasabah</label>
              <input
                type="text"
                value={nama}
                onChange={(e) => setNama(e.target.value)}
                placeholder="Nama lengkap sesuai KTP"
                required
              />
            </div>
            <div className="form-group">
              <label>NIK</label>
              <input
                type="text"
                value={nik}
                onChange={(e) => setNik(e.target.value)}
                placeholder="Nomor Induk Kependudukan"
                required
              />
            </div>
            <div className="form-group">
              <label>No Handphone</label>
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="08xxxxxxxxxx"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Buat password untuk nasabah"
                required
              />
            </div>
            <div className="form-group">
              <label>Konfirmasi Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Ulangi password"
                required
              />
            </div>

            {msg && (
              <motion.div
                className={`message ${msg.includes("berhasil") ? "success" : "error"}`}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
              >
                {msg}
              </motion.div>
            )}

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Memproses..." : <><Save size={18} /> Simpan Akun</>}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
